/*********************
* validate email
**********************/
validateEmail = (email) => {
    return String(email)
    .toLowerCase()
    .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
};

/*********************
* validate password
**********************/
validatePassword = (password) => {
    const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~])[A-Za-z\d!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?`~]{10,64}$/;
    return passwordRegex.test(password);
};

/*********************
* validate phone
**********************/
validateNumberWithPlus = (input) => {
    const regex = /^\d{1,15}$/;
    return regex.test(input);
}

/****************
* loader show
****************/
glide_ajax_loader_show = () => {
    $('.modal-loader').show();
    $('.message-text').hide();
}

/****************
 * loader hide
****************/
glide_ajax_loader_hide = () => {
    $('.modal-loader').hide();
    $('.message-text').show();
}

/**************************
 * toggle show password
**************************/
let passwordInput = document.getElementById("password");
let cPasswordInput = document.getElementById("confirm-password");
let togglePassword = document.getElementById("toggle-password");
let toggleCpassword = document.getElementById("toggle-cpassword");
if( togglePassword ) {
    togglePassword.addEventListener("click", function () {
        // Toggle the class 'display-password' on the current span element
        this.classList.toggle("display-password");
        // Optionally, you can toggle the input type if needed
        if( passwordInput ) {
            let type = passwordInput.getAttribute("type") === "password" ? "text" : "password";
            passwordInput.setAttribute("type", type);
        }
    });
}
if( toggleCpassword ) {
    toggleCpassword.addEventListener("click", function () {
        // Toggle the class 'display-password' on the current span element
        this.classList.toggle("display-password");
        // Optionally, you can toggle the input type if needed
        if( cPasswordInput ) {
            let type = cPasswordInput.getAttribute("type") === "password" ? "text" : "password";
            cPasswordInput.setAttribute("type", type);
        }
    });
}